import { render } from "./index.vue?vue&type=template&id=8ba9244e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8ba9244e&lang=less&scoped=true"

import exportComponent from "F:\\p_for_tw\\maomeng\\users\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba9244e"]])

export default __exports__